var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignTasktoCandidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.422,
    height: 14.657,
    viewBox: "0 0 14.422 14.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-outline-alerted",
    transform: "translate(-10.66 -2.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M24.514,16.516H22.2v.044l1.573.481v1.224l-1.573.481-.044.219-.393.918-.131.219.787,1.442-.874.874L20.1,21.63l-.219.131a4.149,4.149,0,0,1-.918.393l-.219.044-.481,1.573H17.041L16.56,22.2l-.219-.044-.918-.393-.219-.131-1.442.787-.874-.874.787-1.442-.131-.219a4.149,4.149,0,0,1-.393-.918l-.044-.219-1.573-.481V17.041L13.02,16.6l.087-.219a3.71,3.71,0,0,1,.393-.961l.131-.219-.743-1.442.874-.874,1.4.787.219-.131a3.71,3.71,0,0,1,.961-.393l.219-.087.481-1.53h1.224l.481,1.486.612-1.005-.262-.874a.749.749,0,0,0-.7-.481H16.91a.613.613,0,0,0-.612.524L15.9,12.408a1.931,1.931,0,0,0-.7.262l-1.136-.612a.735.735,0,0,0-.83.131L12.19,13.239a.735.735,0,0,0-.131.83l.568,1.093c-.087.219-.175.481-.262.7l-1.224.393a.71.71,0,0,0-.481.656V18.4a.7.7,0,0,0,.524.656l1.224.393.262.656-.612,1.136a.735.735,0,0,0,.131.83l1.049,1.049a.735.735,0,0,0,.83.131l1.136-.612.656.262.393,1.267a.71.71,0,0,0,.656.481H18.4a.71.71,0,0,0,.656-.481l.393-1.267.656-.262,1.136.612a.735.735,0,0,0,.83-.131l1.049-1.049a.735.735,0,0,0,.131-.83L22.635,20.1l.262-.656,1.267-.393a.71.71,0,0,0,.481-.656V16.91a.7.7,0,0,0-.131-.393Z",
    transform: "translate(0 -7.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M62.222,64.364a2.185,2.185,0,1,1,0-4.37.744.744,0,0,1,.306.044,1.932,1.932,0,0,1-.087-.874h-.219a3.059,3.059,0,1,0,3.059,3.059,3.283,3.283,0,0,0-.219-1.136H64.1a1.973,1.973,0,0,1,.306,1.093A2.164,2.164,0,0,1,62.222,64.364Z",
    transform: "translate(-44.526 -52.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M113.957,2.742l-2.535,4.327a.6.6,0,0,0,.131.787.471.471,0,0,0,.35.087h5.026a.542.542,0,0,0,.568-.524,1.028,1.028,0,0,0-.087-.35l-2.491-4.327a.614.614,0,0,0-.787-.219C114.044,2.611,114,2.7,113.957,2.742Z",
    transform: "translate(-92.414)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignTasktoCandidate);
export default __webpack_public_path__ + "static/media/Assign Task to Candidate.17659599b1cdd7bb83ebaf07948f6ead.svg";
export { ForwardRef as ReactComponent };